import Button from "../../Shared/Primitive/Button"
import "../../../Styles/main.scss"

type FrontendUpdateModalProps = {
    onReload: () => void
}

function FrontendUpdateModal({ onReload }: FrontendUpdateModalProps) {
    return (
        <div className="delete-room-modal">
            <div className="delete-room-modal__content">
                <div className="delete-room-modal__upper-panel">
                    <div className="delete-room-modal__title">Update verfügbar 🚀</div>
                </div>
                <div className="delete-room-modal__middle-panel">
                    <div className="delete-room-modal__text">
                        Wir haben eine aktuellere Version der Plattform für dich bereitgestellt. 
                        Bitte aktualisiere kurz die Seite, damit du von den neusten Verbesserungen und Features profitieren kannst!
                    </div>
                </div>
                <div className="delete-room-modal__button-container">
                    <div className="delete-room-modal__button" style={{ width: "11rem" }}>
                        <Button
                            onClick={onReload}
                            className="button button--font-size-small button--font-weight-400 button--text-color-white button--color-gold button--hover-brighter button--cursor-pointer button--border-radius-05"
                        >
                            Seite aktualisieren
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FrontendUpdateModal
